import { apiUrl } from '../../shared/api/apiConfig';

export async function brokerAdminRequest(path, credentials, options = {}) {
  const response = await fetch(apiUrl(`/broker-admin${path}`), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Broker-Admin-Key': credentials.apiKey,
      'X-Broker-Admin-Actor': credentials.actor || 'web-admin',
      ...options.headers,
    },
  });

  const body = response.status === 204 ? null : await response.json().catch(() => null);
  if (!response.ok) {
    const validationMessage = body?.errors
      ? Object.values(body.errors).flat().join(' ')
      : '';
    throw new Error(
      body?.message
      || validationMessage
      || body?.title
      || `Broker administration request failed (${response.status}).`,
    );
  }

  return body;
}
